import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoHy: CultureInfo = {
  name: 'hy',
  displayName: 'Armenian',
  iso3LanguageCode: 'hye',
  iso2LanguageCode: 'hy',
  ietfLanguageTag: 'hy',
  parent: null
};
